/**
 * Course program section row.
 */
import React, { useMemo, useState } from "react";
import { Icon } from "@iconify/react";
import { Link, useParams } from "react-router-dom";
import { Box, Collapse } from "@mui/material";
import PropTypes from "prop-types";

import { VButton, VText } from "form";
import { useAsterController } from "context";
import { asArray, asObject } from "utils/safeData";

/**
 * One outline section with progress and a link into the player.
 *
 * @param {{ section: Object, sectionIdx: number }} props
 */
const CourseProgramItem = (props) => {
  const { courseId } = useParams();
  const section = asObject(props.section);
  const sectionIdx = props.sectionIdx;
  const sequences = asArray(section.sequences);

  const [controller] = useAsterController();
  const { themes } = controller;

  const colorMain1 = useMemo(
    () => (themes || []).find((v) => v.name === "color_main1")?.value || "#E40473",
    [themes]
  );
  const leftBorderSx = { borderLeftColor: `${colorMain1} !important`, borderLeftStyle: "solid !important" };

  const [open, setOpen] = useState(false);

  return (
    <Box className="mb-2">
      <VButton
        className="flex justify-between items-center w-full rounded-md border border-solid border-gray-300 dark:border-gray-500 md:border-l-8 border-l-4 px-2 md:px-10 py-3 md:py-5 cursor-pointer"
        sx={leftBorderSx}
        onClick={() => setOpen(!open)}
      >
        <VText className="text-lg text-limit-1">{section.section_title}</VText>
        {!open && <Icon icon="bi:chevron-right" />}
        {open && <Icon icon="bi:chevron-down" />}
      </VButton>
      <Collapse in={open} timeout="auto">
        {sequences.map((sequence, sequenceIdx) => (
          <Box key={sequence.sequence_id}>
            <VText color="secondary" className="mt-4 ml-6" div>
              {sequence.sequence_title}
            </VText>

            <Box className="my-5 pl-6">
              {asArray(sequence.verticals).map((vertical, verticalIdx) => (
                <Link key={vertical.vertical_id} to={`/content/${courseId}/${sectionIdx}/${sequenceIdx}/${verticalIdx}`} className="no-underline flex items-center gap-4 mt-5">
                  <VButton className="flex justify-between items-center rounded-md border border-solid border-gray-300 dark:border-gray-500 md:border-l-8 border-l-4 px-8 py-2 cursor-pointer w-full" sx={leftBorderSx}>
                    <VText className="text-lg">{vertical.vertical_title}</VText>
                  </VButton>
                </Link>
              ))}
            </Box>
          </Box>
        ))}
      </Collapse>
    </Box>
  );
};

CourseProgramItem.propTypes = {
  section: PropTypes.object,
  sectionIdx: PropTypes.number,
};

export default CourseProgramItem;
